<template>
  <div>
    <logged-in-header :show-menu="false" />
    <client-coupon />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import clientCoupon from "../components/client-coupon/ClientCoupon";

export default {
  components: {
    loggedInHeader,
    clientCoupon
  }
};
</script>
